<template>
  <div class="tw-container tw-text-center">

    <router-link v-bind:to="'/company-add'">
      <div class="tw-w-80 tw-mx-auto tw-bg-light-green tw-text-white tw-rounded-md tw-py-2 tw-mb-4">
        <img src="/images/icons/icon_add_company_white.svg" class="tw-w-10 tw-mx-auto"/>
        สร้างบริษัท / ร้านค้าของคุณ
      </div>
    </router-link>

    <router-link v-bind:to="'/company-add-with-code'">
      <div class="tw-w-80 tw-mx-auto tw-border tw-border-light-green tw-text-light-green tw-rounded-md tw-py-2 tw-mb-10">
        เพิ่มบริษัทด้วยโค้ด
      </div>
    </router-link>

    <div v-if="loading" class="tw-py-4 tw-pb-40">
      <v-progress-circular :size="40" color="primary" indeterminate></v-progress-circular>
    </div>

    <div v-if="!loading" class="tw-py-4 tw-pb-40 tw-w-96 tw-mx-auto tw-border-t tw-border-gray-500">
      อยากลองใช้งานก่อนมั้ย? <span @click="submitDemo" class="tw-text-light-green tw-font-bold tw-cursor-pointer">ทดลองใช้งานบริษัทต้นแบบ</span>
    </div>

  </div>
</template>

<script>

import createCompany from "@/libs/createCompany";
import mockDataDemo from "@/libs/mockDataDemo";

export default {
  name: "menuRegisterCompany",
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    submitDemo: async function (e) {
      e.preventDefault();
      this.loading = true
      let companyObject = {
        nameTH: "บริษัท ทดสอบ จำกัด",
        nameEN: "Test Co.,Ltd.",
        taxID: "0105556154812",
        withholdingTaxToken: "",
        withholdingTaxShipping: "",
        address:{
          addressNo: "598",
          building: "อาคารคิวเฮาส์เพลินจิต ชั้น 6",
          village: "",
          alley: "",
          street: "",
          province: "กรุงเทพฯ",
          district: "ลุมพินี",
          subDistrict: "ปทุมวัน",
          postCode: "10330",
        },
        officeNumber:"026637895",
        faxNumber:"026637880",
        phoneNumber:"026637895",
        email: "hello@phasicharoen.com",
        imageLogoPath: "gs://sld-etax.appspot.com/Users/H68hCp4egzboVi4nmmpuW2jqFRO2/Companies/9HF2imZ4yPN4eGis3sKI/Logos/1616393765644.jpg",
        imageLogoUrl: "https://lh3.googleusercontent.com/TrCzEzI0N6WZv47sP6JT3TL3A-YkMpW19H8HdMswPEqVv6tUbQV01PU83cRVT8zCPdu4_AcIl0IzwzFemB0UuzBSgI62EwAb",
        logo: "",
        isDemo: true
      }
      let companyId = await createCompany(companyObject, this.$store.dispatch, true)
      await mockDataDemo(companyId)
      await this.$store.dispatch('companies/getList')
      this.loading = false
    },
  }
}
</script>
